import api from '../../api'

export const getBanners = () => {
  return api.get('/cms/banners')
}

export const getBannersById = (id = null) => {
  return api.get(`/cms/banners/${id}`)
}
